import React, { useState, useEffect } from 'react'
import { useQuery } from '@apollo/client'
import { QUERY_MERCHANT_SIGNATURE_AND_TERMS } from '../SettingsQueries'
import { Tabs, Tooltip } from 'antd'
import { urlChanger } from './utils'
import GeneralTerms from './GeneralTerms'
import DispatchTerms from './DispatchTerms'
import { useMerchant } from 'hooks/useGlobalContext'

const { TabPane } = Tabs

const TermsAndConditions = () => {
  const { merchantData } = useMerchant()
  const [activeTab, setActiveTab] = useState('general')
  const { data, loading } = useQuery(QUERY_MERCHANT_SIGNATURE_AND_TERMS, {
    variables: { merchantId: merchantData.id }
  })

  useEffect(() => {
    const tab = window.location.pathname.split('/')[3]

    if (['general', 'dispatch'].includes(tab)) {
      setActiveTab(tab)
    }
  }, [])

  const tabChangeHandler = (key: string) => {
    urlChanger(key)
    setActiveTab(key)
  }

  const latestData = data?.signatures[0]

  return (
    <Tabs activeKey={activeTab} onChange={tabChangeHandler} className='_mb-8'>
      <TabPane
        key='general'
        tab={
          <Tooltip title='General Terms & Conditions'>
            <span>General Terms & Conditions</span>
          </Tooltip>
        }
      >
        <GeneralTerms isLoading={loading} latestData={latestData} />
      </TabPane>

      <TabPane
        key='dispatch'
        tab={
          <Tooltip title='Dispatch Terms & Conditions'>
            <span>Dispatch Terms & Conditions</span>
          </Tooltip>
        }
      >
        <DispatchTerms />
      </TabPane>
    </Tabs>
  )
}

export default TermsAndConditions
